let $header = $('.header');
let $menu = $('.menu');
let $menuInner = $('.menu__inner');
let $menuHead = $('.menu__head');
let $menuIcon = $('.menu-icon');
let $menuBg = $('.menu-bg');
let $menuBgCol2 = $('.menu-bg__col2');
let $menuBgCol2Mask = $('.menu-bg__col2__mask');
let $menuContent = $('.menu__content');
let $menuLinksCol = $('.menu__col');
let $menuLinks = $('.menu__col a');
let $menuLinks1 = $('.menu__col--1 a');
let $menuLinks2 = $('.menu__col--2 a');
let $menuSocial = $('.menu__social');
let $menuInfo = $('.menu__info');

let menuBehavior = {
	isMoving: false,

	show() {
		let self = this;

		$(document).trigger('popup.Open');

		self.isMoving = true;
		$('body').addClass('is-menu-opened');

		TweenMax.set($menuContent, {
			opacity: 1,
			y: 0,
		});

		new TimelineMax({
			onComplete() {
				self.isMoving = false;
			},
		})
			.to($menu, 0, {
				display: 'flex',
			})
			.to($header, 0.3, {
				animation: 'none',
				y: '-100%',
				ease: 'default',
			}, 0)
			.to($menuInner, 0.8, {
				height: '100%',
				ease: 'default',
			}, 0)
			.to($menuBgCol2Mask, 0.8, {
				scaleY: 1,
				ease: 'default',
			}, 0.2)
			.add(() => {
				$menuLinksCol.each((i, col) => {
					let curDelay = i * 0.1;

					$(col).find('a').each((j, elem) => {
						TweenMax.to(elem, 0.7, {
							opacity: 1,
							delay: j * 0.05 + curDelay,
							ease: 'default',
						});
					});
				});
			}, 0.3)
			.to($menuHead, 0.8, {
				y: 0,
				ease: 'default',
			}, 0.6)
			.to($menuSocial, 0.8, {
				opacity: 1,
				y: 0,
				ease: 'default',
			}, '-=0.7')
			.to($menuInfo, 0.7, {
				opacity: 1,
				y: 0,
				ease: 'default',
			}, '-=0.7');
	},

	hide() {
		if ($('body').hasClass('is-menu-opened')) {
			let self = this;

			self.isMoving = true;

			new TimelineMax({
				onComplete() {
					self.isMoving = false;
					$('body').removeClass('is-menu-opened');

					TweenMax.set([
						$menuLinks,
						$menuBgCol2Mask,
					], {
						clearProps: 'opacity, transform',
					});

					$(document).trigger('popup.Close');
				},
			})
				.to($menuContent, 0.3, {
					opacity: 0,
					y: 20,
					ease: 'default',
				})
				.to($menuHead, 0.3, {
					y: '-100%',
					ease: 'default',
					clearProps: 'transform',
				}, '-=0.2')
				.to($menuSocial, 0.3, {
					opacity: 0,
					y: 80,
					ease: 'default',
				}, '-=0.3')
				.to($menuInfo, 0.3, {
					opacity: 0,
					y: 80,
					ease: 'default',
				}, '-=0.3')
				.to($menuInner, 0.8, {
					height: 0,
					ease: 'default',
				}, '-=0.2')
				.to($menu, 0, {
					display: 'none',
				})
				.add(() => {
					if (!$header.hasClass('is-fixed')) {
						TweenMax.to($header, 0.3, {
							y: '0%',
							ease: 'default',
							clearProps: 'animation',
						});
					} else {
						TweenMax.set($header, {
							clearProps: 'animation, transform',
						});
					}
				});
		}
	},
};

$('.menu-btn').on('click', (e) => {
	$(e.currentTarget).blur();

	menuBehavior.show();
});

$('.menu__close').on('click', (e) => {
	$(e.currentTarget).blur();

	menuBehavior.hide();
});

$('.page').on('click', () => {
	menuBehavior.hide();
});

$(document).on('keydown', (e) => {
	if (e.keyCode === 27) {
		menuBehavior.hide();
	}
});

$('.menu__col a').hover((e) => {
	let $item = $(e.currentTarget);
	let $parent = $(e.currentTarget).closest('.menu__col');
	let order = $item.data('link');

	if (menuBehavior.isMoving) {
		return;
	}

	if ($parent.hasClass('menu__col--1')) {
		$menu.addClass('is-col1-hovered');
		$('.menu__col--1').addClass('is-col-hovered');

		new TimelineMax()
			.to($('.menu-bg__col1').find('.image'), 0.5, {
				opacity: 1,
				ease: 'default',
			}, 0);
	} else {
		$menu.addClass('is-col2-hovered');
		$('.menu__col--2').addClass('is-col-hovered');

		new TimelineMax()
			.to($menuIcon.find('.menu-icon__col2 svg'), 0.05, {
				opacity: 0.05,
				fill: '#ffffff',
				ease: 'default',
			}, 0)
			.to($('.menu-bg__col2').find('.image').not($(`.image[data-link="${order}"]`)), 0.5, {
				opacity: 0,
				ease: 'default',
			}, 0)
			.to($('.menu-bg__col2').find(`.image[data-link="${order}"]`), 0.5, {
				opacity: 1,
				ease: 'default',
			}, 0);
	}
}, () => {
	$menu.removeClass('is-col1-hovered is-col2-hovered');
	$('.menu__col--1').removeClass('is-col-hovered');
	$('.menu__col--2').removeClass('is-col-hovered');

	new TimelineMax()
		.to($menuIcon.find('.menu-icon__col2 svg'), 0.5, {
			fill: '#0e2026',
			opacity: 0.03,
			ease: 'default',
		}, 0)
		.to($('.menu').find('.image'), 0.5, {
			opacity: 0,
			ease: 'default',
		}, 0);
});
